import Axios, { CancelTokenSource } from "axios";

import { API } from "utils/api-config";

import { defaultErrorResponse } from "api/defaults";

import { Tenant } from "store/environments/environment-types";
import {
    StorageAccount,
    ManagementPolicyRule,
} from "store/storage-accounts/storage-accounts-types";
import { ManagementPolicyRulesWorkflow } from "store/workflows/workflows-types";
import { OperationErrorLog } from "store/common/operation-types";
import constants from "../../utils/constants";

export const loadStorageAccounts = async (
    environmentId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[ReadonlyArray<Tenant<StorageAccount>> | null, number]> => {
    const response = await API.get(
        `/environments/${environmentId}/storage-accounts`,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }
        if (response.status !== constants.statusCode.OK) {
            return [response.data, response.status];
        }

        return [response.data.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};

export const loadManagementPolicyRules = async (
    environmentId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[ReadonlyArray<ManagementPolicyRule> | null, number]> => {
    const response = await API.get(
        `/environments/${environmentId}/storage-accounts/management-policy-rules/default`,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }
        if (response.status !== constants.statusCode.OK) {
            return [response.data, response.status];
        }

        return [response.data.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};

export const createManagementPolicyRules = async (
    environmentId: string,
    payload: ReadonlyArray<Tenant<StorageAccount>>,
    cancelTokenSource?: CancelTokenSource
): Promise<[ManagementPolicyRulesWorkflow | null, number]> => {
    const response = await API.post(
        `/environments/${environmentId}/storage-accounts/management-policy-rules`,
        payload,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};

export const loadManagementPolicyRulesWorkflow = async (
    environmentId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[ManagementPolicyRulesWorkflow | null, number]> => {
    const response = await API.get(
        `/environments/${environmentId}/storage-accounts/management-policy-rules/workflows/default`,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};

export const loadManagementPolicyRulesErrors = async (
    environmentId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<
    [ReadonlyArray<OperationErrorLog<Tenant<StorageAccount>>> | null, number]
> => {
    const response = await API.get(
        `/environments/${environmentId}/storage-accounts/management-policy-rules/errors`,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};
